const accordion = document.querySelectorAll('[data-calendar-accordion]')

if (accordion.length > 0) {
	for (let i = 0; i < accordion.length; i++) {
		const accordionItems = accordion[i].querySelectorAll('[data-calendar-accordion-item]')

		if (accordionItems) {
			servicesAccordion(0)
		}

		function servicesAccordion(index) {
			accordionItems[index].classList.add('active')
			let content = accordionItems[index].querySelector('[data-calendar-accordion-content]')
			content.style.maxHeight = content.scrollHeight + 'px'

			accordionItems.forEach((el, index) => {
				el.addEventListener('click', (e) => {
					let self = e.currentTarget
					let content = self.querySelector('[data-calendar-accordion-content]')


					if (self.classList.contains('active')) {
						self.classList.remove('active')
						content.style.maxHeight = null
					} else {
						clearActiveClass()
						self.classList.toggle('active')
						content.style.maxHeight = content.scrollHeight + 'px'
					}
				})
			})

			function clearActiveClass() {
				accordionItems.forEach(el => {
					el.classList.remove('active')
					el.querySelector('[data-calendar-accordion-content]').style.maxHeight = null
				})
			}
		}

	}
}
